import { Component } from "@angular/core";

@Component({
  selector: "app-home-services",
  templateUrl: "./home-services.component.html",
  styleUrls: ['./home-services.component.scss'],
  standalone: false,
})
export class HomeServicesComponent {}
